<template>
  <div class="search-container">
    <div class="block-search">
      <textarea rows="5" v-model="url" />
      <button @click="testMetadata">
        Test metadata
      </button>
    </div>
    <VLoadSpinner v-if="isLoading"
                  class="metadata-loading"
                  :is-loading="isLoading"
                  color="#454545"
    />
    <div class="block" v-for="(result, source) in results" :key="source">
      <div class="json">
        <h3>{{ source }}</h3>
        <h4 v-if="result.all">
          All fetched metadata
        </h4>
        <pre v-if="result.all">{{ JSON.stringify(result.all, undefined, 2) }}</pre>
        <h4 v-if="result.all">
          Extracted metadata
        </h4>
        <pre>{{ JSON.stringify(result.metadata, undefined, 2) }}</pre>
      </div>
      <LinkMetadataCover v-if="result.metadata"
                         class="preview"
                         :title="result.metadata.title"
                         :description="result.metadata.description"
                         :image="result.metadata.image"
                         :url="result.metadata.url"
      />
    </div>
  </div>
</template>
<script>
import VLoadSpinner from '../shared/VLoadSpinner'
import LinkMetadataCover from '../shared/LinkMetadataCover'

export default {
  name: 'TestMetadataPage',
  components: {
    LinkMetadataCover,
    VLoadSpinner
  },
  data() {
    return {
      url: '',
      isLoading: false,
      results: {}
    }
  },
  methods: {
    testMetadata() {
      this.isLoading = true
      this.results = {}
      this.$store.dispatch('testMetadata', this.url)
        .then(results => {
          this.results = results
          this.isLoading = false
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })
    }
  }
}
</script>
<style scoped lang="scss">
.search-container {
  width: 100%;
}

.block-search {
  padding: 16px;
  margin: 16px;
  background-color: white;

  textarea {
    width: 50%;
  }
}

.block {
  padding: 16px;
  margin: 16px;
  background-color: white;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .json {
    width: calc(100% - 600px);

    pre {
      white-space: pre-wrap;
    }
  }

  .preview {
    width: 500px;
    flex: none;
  }
}
</style>
